import { api } from 'boot/axios.js'
import { Cookies } from 'quasar'

export async function login(ctx, data) {
  try {
    const response = await api({
      url: 'auth/token',
      method: 'POST',
      data
    })

    const options = {
      secure: process.env.PROD,
      expires: parseInt(response.data.tokenLife) / 60 / 1000,
      path: '/'
    }

    Cookies.set('auth_token', response.data.token, options)
    Cookies.set('auth_token_life', response.data.tokenLife, options)
    Cookies.set('auth_token_type', response.data.type, options)

    options.expires = parseInt(response.data.refreshTokenLife) / 60 / 1000
    Cookies.set('refresh_token', response.data.refreshToken, options)
    Cookies.set('refresh_token_life', response.data.refreshTokenLife, options)

    ctx.commit('isAuthenticated', true)

    api.defaults.headers.common['Authorization'] =
      'Bearer ' + response.data.token

    return response
  } catch (e) {
    throw e
  }
}

export async function recover(ctx, data) {
  try {
    const response = await api({
      url: 'auth/recover-password',
      method: 'post',
      data: data
    })
    return response
  } catch (e) {
    throw e
  }
}

export async function resetPassword(ctx, data) {
  try {
    const response = await api({
      url: 'auth/reset-password',
      method: 'POST',
      data: data
    })
    return response
  } catch (e) {
    throw e
  }
}

export async function change(ctx, data) {
  try {
    const response = await api({
      url: 'auth/change-password',
      method: 'post',
      data: data
    })
    return response
  } catch (e) {
    throw e
  }
}

export async function logout(ctx, data = {}) {
  try {
    const response = await api({
      url: 'auth/revoke',
      method: 'post',
      data: data
    })

    const options = { path: '/' }

    Cookies.remove('auth_token', options)
    Cookies.remove('auth_token_life', options)
    Cookies.remove('auth_token_type', options)

    Cookies.remove('refresh_token', options)
    Cookies.remove('refresh_token_life', options)

    ctx.commit('isAuthenticated', false)

    delete api.defaults.headers.common['Authorization']

    return response
  } catch (e) {
    throw e
  }
}

export function clear(ctx) {
  ctx.commit('isAuthenticated', false)

  const options = { path: '/' }

  Cookies.remove('auth_token', options)
  Cookies.remove('auth_token_life', options)
  Cookies.remove('auth_token_type', options)
  Cookies.remove('refresh_token', options)
  Cookies.remove('refresh_token_life', options)

  delete api.defaults.headers.common['Authorization']
}

export function isAuthenticated(ctx, data) {
  ctx.commit('isAuthenticated', data)
}
